module.exports = __webpack_public_path__ + "img/se.0d817a1d.svg";